import CQLBar from './component'

import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'

const mapStateToProps = state => ({
  selectedGoalAction: PlaybookSelectors.selectedGoalAction(state),
})

export default compose(
  connect(mapStateToProps),
  withProps(props => ({
    selectedScore: _.get(props.selectedGoalAction, 'markCQL.score', null),
  }))
)(CQLBar)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ActionConfigCQL/index.js